import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-headset',
  templateUrl: './headset.component.html',
  styleUrls: ['./headset.component.scss']
})
export class HeadsetComponent {

  @Input()
  public title: string;

  @Input()
  public addButtonName: string;

  @Input()
  public start: ActivatedRoute;

  @Output()
  public addButtonClick = new EventEmitter();

  constructor(public route: ActivatedRoute) { }

  onAddClick() {
    this.addButtonClick.emit();
  }

}
